import React from 'react';

import { WebCopy, Input } from 'components';

interface TokenInputProps {
  className: any;
  tokenLabel: any;
  token: any;
  errors: any;
  handleTokenChanged: any;
}

export const TokenInput: React.FC<TokenInputProps> = ({
  className,
  tokenLabel,
  token,
  errors,
  handleTokenChanged,
}) => {
  return (
    <>
      <Input
        className={className}
        error={!!errors.token}
        fullWidth
        label={tokenLabel}
        value={token}
        onChange={handleTokenChanged}
      />
      {!!errors.token ? <WebCopy type="Error">{errors.token}</WebCopy> : null}
    </>
  );
};
